export function downloadCsvFile(content: any, filename: string) {
  const _utf = '\uFEFF' // 为了使Excel以utf-8的编码模式，同时也是解决中文乱码的问题
  // 字符内容转变成blob地址
  const csvData: Blob = new Blob([_utf + content], { type: 'text/csv' })
  const downloadUrl: string = URL.createObjectURL(csvData)
  window.open(downloadUrl)
  const oWin: Window = window.top.open('about:blank', '_blank') as Window
  oWin.document.write(csvData + '')
  oWin.document.close()
  oWin.document.execCommand('SaveAs', true, filename)
  oWin.close()
}

/** 添加csv格式字符串 */
function getCsvDownloadUrl(csvData: string): string {
  const _utf: string = '\uFEFF' // 为了使Excel以utf-8的编码模式，同时也是解决中文乱码的问题
  return 'data:attachment/csv;charset=utf-8,' + _utf + encodeURIComponent(csvData)
}

/**
 * 保存字符串格式的表格数据为.csv文件
 * @params dsvData 字符串数据
 * @params fileName 文件名
 */
export function SaveCsvDataAs(csvData: string, fileName: string) {
  const alink = document.createElement('a')
  alink.id = 'linkDwnldLink'
  alink.href = getCsvDownloadUrl(csvData)
  document.body.appendChild(alink)
  const linkDom: any = document.getElementById('linkDwnldLink')
  linkDom.setAttribute('download', fileName)
  linkDom.click()
  document.body.removeChild(linkDom)
}
